import React, { useState } from "react";
import { Link } from 'react-router-dom';
import '../../assets/css/whatsappsharing.css';

const Whatsappcatlog = () => {
  const [open, setOpen] = useState(false);
  const toggleDropdown = () => setOpen(!open);

  return (
      <> 

     <div className="relative inline-block" style={{ position: "absolute", top:"-4px", right:"-4px", background:"rgb(255 255 255 / 72%)", width:"28px", height:"28px", borderRadius:"30px", fontSize:"12px", display:"block", paddingTop:"7px", paddingRight:"10px"}}>
      {/* Dropdown Button */}
      <Link onClick={toggleDropdown} style={{textDecoration:"none", marginLeft:"7px"  }}>
           <i className="bi bi-share-fill" style={{color:"#000"}}></i>
      </Link>
      {/* Dropdown Menu */}
      {open && (
        <div className="absolute mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-10 box-rto" style={{ top:"31px"}} >
          <Link
            to={`https://wa.me/?text=${encodeURIComponent(window.location.href)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center" style={{textaling:"center", padding:"2px 5px"}}
            >
            <i className="bi bi-whatsapp text-green-600"></i>
          </Link>
        </div>
      )}
    </div>
      
      </>
  );
};
export default Whatsappcatlog;
